import { fetchAllCategories } from 'actions';
import Navbar from 'components/Navbar';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCustomerId } from 'selectors/auth';
import { getOutcomeFromCampaignRuleOutcome } from 'selectors/outcomes';
import { useSelector } from 'store';
import { useHistory } from 'utils/urls';
import OutcomeManagerSidebar from './OutcomeManagerSidebar';
import OutcomeTable from './OutcomeTable';

type RouterParams = {
  ruleId: string;
};

const OutcomeManagerStarship: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { ruleId } = useParams<RouterParams>();

  const outcomes = useSelector(getOutcomeFromCampaignRuleOutcome);
  const customerId = useSelector(getCustomerId);

  useEffect(() => {
    dispatch(
      fetchAllCategories({
        rule_uuids: [ruleId],
        customer_uuids: [customerId || ''],
        relationships: ['outcome', 'rule_head'],
        include_staging: 'true',
      })
    );
  }, [dispatch, customerId, ruleId]);

  if (!outcomes) return null;

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="flex flex-col bg-white min-w-screen overflow-hidden"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />

      <div className="flex flex-row h-full overflow-hidden">
        <div className="h-full flex flex-col gap-4 py-8 px-6 w-9/12 overflow-hidden">
          <header>
            <div className="flex flex-col gap-2">
              <span>
                <button
                  type="button"
                  className="text-small hover:underline"
                  onClick={(): void => {
                    history.goBack();
                  }}
                >
                  {'< Back'}
                </button>
              </span>

              <h2 className="text-heading-1">Outcome Manager</h2>
            </div>
          </header>
          <main className="h-full flex flex-col gap-8 overflow-hidden">
            <OutcomeTable ruleGroupId={ruleId} group="production" />
            <OutcomeTable ruleGroupId={ruleId} group="staging" />
          </main>
        </div>
        <div className="w-3/12 min-h-wo-navbar h-wo-navbar overflow-y-scroll">
          <OutcomeManagerSidebar />
        </div>
      </div>
    </div>
  );
};

export default OutcomeManagerStarship;
